/**
 * Local initials avatar — a data URI, no network, no dead third-party
 * placeholder service. The donor project pointed missing photos at
 * via.placeholder.com, which no longer resolves and threw a connection
 * error on every Acaryas render.
 */
export const initialsAvatar = (name = '?') => {
  const initial = String(name).trim().charAt(0).toUpperCase() || '?';
  const svg =
    `<svg xmlns="http://www.w3.org/2000/svg" width="150" height="150">` +
    `<rect width="150" height="150" fill="#150E2E"/>` +
    `<circle cx="75" cy="75" r="70" fill="none" stroke="#E8B84B" stroke-opacity="0.3" stroke-width="2"/>` +
    `<text x="75" y="97" font-family="Georgia, serif" font-size="64" fill="#E8B84B" text-anchor="middle">${initial}</text>` +
    `</svg>`;
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
};
